import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import _ from 'lodash'
import AuthService from '@/services/authService'
import FireService from '@/services/fireService'

import { BreadstickBakery } from 'breadstick'
Vue.use(BreadstickBakery)

import '@/assets/css/tailwind.css'
import 'vue-swipe-actions/dist/vue-swipe-actions.css';
Vue.prototype.$_ = _
Vue.prototype.AuthService = AuthService
Vue.prototype.FireService = FireService

import * as firebase from "firebase/app";

import "firebase/analytics";

import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCkP0Hmw-vtr0PvPjcAkOaptJn7AG7bySU",
    authDomain: "personal-cookbook.firebaseapp.com",
    databaseURL: "https://personal-cookbook.firebaseio.com",
    projectId: "personal-cookbook",
    storageBucket: "personal-cookbook.appspot.com",
    messagingSenderId: "463769656062",
    appId: "1:463769656062:web:ceb509c62110852d11a3af",
    measurementId: "G-LXY7FKL4F8"
};

firebase.initializeApp(firebaseConfig);

Vue.prototype.$firebase = firebase;

Vue.config.productionTip = false

let app;

firebase.auth().onAuthStateChanged(async(user) => {
    if (!app) {
        app = new Vue({
            router,
            store,
            render: h => h(App)
        }).$mount('#app')
    }

    store.dispatch("setCurrentUser", user);
    if (user) {
        await FireService.getRecipes();
    }
});